export { CarDetails } from "./CarDetails";
export type { ICarDetailsProps, ICarDetailsTranslations } from "./CarDetails";
